import id from './id';
import initialState, { PREFILL_OPTIONS, } from './initial-state';
import selectorDefinitions from './selectors';
const areAmountsEqual = (nu1, nu2) => {
    if (nu1 === null && nu2 === null)
        return true;
    if (!nu1 || !nu2)
        return false;
    if (!nu1.unitType.equals(nu2.unitType))
        return false;
    return nu1.equals(nu2);
};
const exchangeReduxDefinition = {
    id,
    type: 'redux-module',
    initialState,
    eventReducers: {
        exchangeQuotes: (state, payload) => ({
            ...state,
            quotes: payload,
        }),
        exchangeStatus: (state, payload) => ({
            ...state,
            status: payload,
        }),
        exchangeAvailability: (state, payload) => ({
            ...state,
            availability: payload,
        }),
        exchangeFromPair: (state, payload) => {
            if (!payload)
                return state;
            const payloadAmount = payload.amount;
            const assetIsEqual = payload.asset === state.form.fromAsset;
            const amountIsEqual = areAmountsEqual(state.form.fromAmount, payloadAmount);
            if (assetIsEqual && amountIsEqual)
                return state;
            return {
                ...state,
                form: {
                    ...state.form,
                    fromAmount: payloadAmount,
                    fromAsset: payload.asset,
                },
            };
        },
        exchangeToPair: (state, payload) => {
            if (!payload)
                return state;
            const payloadAmount = payload.amount;
            const assetIsEqual = payload.asset === state.form.toAsset;
            const amountIsEqual = areAmountsEqual(state.form.toAmount, payloadAmount);
            if (assetIsEqual && amountIsEqual)
                return state;
            return {
                ...state,
                form: {
                    ...state.form,
                    toAmount: payloadAmount,
                    toAsset: payload.asset,
                },
            };
        },
        exchangeSlippage: (state, payload) => ({
            ...state,
            form: {
                ...state.form,
                slippage: payload,
            },
        }),
        exchangePrefillOptionId: (state, payload) => {
            if (state.form.prefillOptionId === payload) {
                return state;
            }
            if (payload && !(payload in PREFILL_OPTIONS)) {
                console.warn(`Ignoring invalid prefillOptionId: ${payload}`);
                return state;
            }
            return {
                ...state,
                form: {
                    ...state.form,
                    prefillOptionId: payload,
                },
            };
        },
    },
    selectorDefinitions,
};
export default exchangeReduxDefinition;
